// extracted by mini-css-extract-plugin
export default {"Primary":"SecondaryButton_Primary__ra1St","Disabled":"SecondaryButton_Disabled__a3d-o","Secondary":"SecondaryButton_Secondary__Swye8","Neutral":"SecondaryButton_Neutral__bYBVc"};